import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { HTTP_STATUSES, PROJECT, PROJECT_SETTINGS, STANDARD_ERRORS_WAY } from "../../../../../utils/consts";
import { checkFilterItem, fetchFilterData } from "../../../../../utils/fetchFilterData";
import { parseAxiosError } from "../../../../../utils/response";
import { findSettings } from "../../../../../utils/settingsFinder";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import DialogModal from "../../../../elements/dialogModal/DialogModal";
import TwoFa from "../../../../elements/twoFa/TwoFa";
import ProjectIpWhitelistItems from "./ProjectIpWhitelistItems";
import DefaultButton from "../../../../styles/materialButtonStyle";

import { StyledProjectWhiteList } from "../styledProjectDetails";
import {
  StyledBlockAction,
  StyledBlockLabel,
  StyledFormBlock,
  StyledFormGrid,
  StyledInputBlock
} from "../../../../styles/styledTabsForm";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";

const ProjectIpWhitelistContainer = ({
  t,
  projectId,
  project,
  notification,
  setNotification
}) => {

  const history = useHistory();

  const [trustedIpAddresses, setTrustedIpAddresses] = useState(null);
  const [oldTrustedIpAddresses, setOldTrustedIpAddresses] = useState("[]");
  const [showButtonSubmit, setShowButtonSubmit] = useState(false);
  const [activeButtonSubmit, setActiveButtonSubmit] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errors, setErrors] = useState([]);
  const [filterData, setFilterData] = useState({
    "currentTab": checkFilterItem(history, "currentTab", "ip-whitelist", false, true),
  });

  const { settings } = project;

  const handleSubmit = (event) => {
    event.preventDefault();

    const ipsValues = trustedIpAddresses.map(item => item.value);

    const data = {
      trustedIpAddress: ipsValues,
      twofa: event.target.twofa.value
    };

    axios.put(`/api/projects/${projectId}/change-trusted-ip`, data, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setNotification({
          visible: true,
          type: "success",
          message: t("details.ipWhitelist.success")
        });
        setOldTrustedIpAddresses(JSON.stringify(ipsValues));
        setShowButtonSubmit(false);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setDialogOpen(false);
    });
  };

  const handleAdd = () => {
    setTrustedIpAddresses([...trustedIpAddresses, { value: "" }]);
    setActiveButtonSubmit(false);
  };

  useEffect(() => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);
  }, []);

  useEffect(() => {
    if (!settings) {
      return;
    }

    const trustedIpAddresses = findSettings(settings, PROJECT_SETTINGS.TRUSTED_IP_ADDRESSES);

    setTrustedIpAddresses(trustedIpAddresses);
    setOldTrustedIpAddresses(JSON.stringify(trustedIpAddresses.map(item => item.value)));
  }, [settings]);

  useEffect(() => {
    if (trustedIpAddresses && JSON.stringify(trustedIpAddresses.filter(item => item.value !== "").map(item => item.value)) !== oldTrustedIpAddresses) {
      setShowButtonSubmit(true);
    } else {
      setShowButtonSubmit(false);
    }
  }, [trustedIpAddresses, oldTrustedIpAddresses]);

  useEffect(() => {
    if (errors && Object.keys(errors)?.length > 0) {
      setActiveButtonSubmit(false);

      return;
    }

    setActiveButtonSubmit(true);
  }, [errors]);

  const renderWhitelistItems = () => {
    if (!trustedIpAddresses) {
      return <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />;
    }

    if (trustedIpAddresses.length === 0 && !showButtonSubmit) {
      return <Alert severity="warning">{t("details.ipWhitelist.empty")}</Alert>;
    }

    return (
      <StyledFormGrid className="grid-form projects-ip-list">
        <StyledFormBlock>
          <StyledBlockLabel>
            IP
          </StyledBlockLabel>
          <StyledInputBlock>
            {trustedIpAddresses.length > 0 ?
              <ProjectIpWhitelistItems
                t={t}
                trustedIpAddresses={trustedIpAddresses}
                setTrustedIpAddresses={setTrustedIpAddresses}
                errors={errors}
                setErrors={setErrors}
                activeButtonSubmit={activeButtonSubmit}
              />
              : <div className="empty-list">{t("details.ipWhitelist.emptyRemoved")}</div>}
          </StyledInputBlock>
          <div className="clear-column" />
        </StyledFormBlock>
        {showButtonSubmit && (
          <StyledFormBlock>
            <div className="clear-column" />
            <StyledBlockAction>
              <DefaultButton
                color="success"
                onClick={() => setDialogOpen(true)}
                disabled={!activeButtonSubmit}
              >
                {t("details.ipWhitelist.submit")}
              </DefaultButton>
            </StyledBlockAction>
            <div className="clear-column" />
          </StyledFormBlock>
        )}
      </StyledFormGrid>
    );
  };

  return (
    <StyledProjectWhiteList>
      <DialogModal
        open={dialogOpen}
        setOpen={setDialogOpen}
        title={t("details.twoFa")}
        content={<TwoFa
          handleSubmit={handleSubmit}
          error={errors}
        />}
      />
      <div className="white-list-head">
        <DefaultButton
          onClick={handleAdd}
          color="success"
          disabled={!activeButtonSubmit || trustedIpAddresses?.length === PROJECT.MAX_TRUSTED_IP_COUNT}
        >
          {t("details.ipWhitelist.add")}
        </DefaultButton>
      </div>
      {renderWhitelistItems()}
    </StyledProjectWhiteList>
  );
};

export default ProjectIpWhitelistContainer;